<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- MainView -->
     <article @click.self="open = false" :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
            <h1 class="info-menu view-name">
                <img src="static/img/assets/nav_people_on.png" alt="">
                {{$t('organizationListStr')}}
            </h1>
            <span class="info-right">
            </span>
        </div>
        <!-- /ViewTitleBox -->
        <section class="animated fadeInRight">
        <!-- 1on1item -->
        <div class="ibox">
            <div class="ibox-content">
                <div class="ibox-title search-box">
                <div class="row">
                    <div class="col-sm-12">
                      <form @submit.prevent>
                        <div class="input-group">
                          <input v-model="searchText" type="text" class="typeahead_2 form-control" :placeholder="$t('searchWithOrganizationName')">
                        </div>
                      </form>
                    </div>
                </div>
                </div>
                <div class="ibox-content search-resultview">
                <ul v-if="searchText == ''">
                  <li id="group1" class="flex-box fl-between group-item cursor">
                    <h4 class="title-label" for="status">{{$t('organizationListStr')}}</h4>
                  </li>
                    <organization-item :userVisibleOrganization="true" :OrganizaitonPath="getOpens" :editAble="false" @onClickOrganization="onClickGroup"/>
                </ul>
                <ul v-else>
                  <li><label>{{$t('searchResuleStrType')}}</label></li>
                  <template v-if="Object.keys(this.getGroupsBySearchText).length === 0">
                    <li><label>{{$t('notFoundOrganizationNameStr')}}</label></li>
                  </template>
                  <template v-else>
                    <organization-item :OrganizaitonPath="organizationSearch" @onClickOrganization="onClickGroup"/>
                  </template>
                </ul>
                </div>
                <!-- /公開設定 -->
            </div>
        </div>
        <!-- /1on1item -->
        </section>
      </article>

      <!-- DetailView -->
      <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
        <div class="close-content"><div @click="open = false" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
        <article class="sub-content-wrap">
          <section class="inner-wrap">
            <div class="s-inner-wrap">
              <div class="ibox-title flex-box fl-between ibox-detail-header">
                <span class="info-menu flex-box">
                  {{ this.targetGroup.groupName }}
                </span>
                <span class="info-right">
                  <span class="group-info">{{$t('memberStr')}}: ({{Object.keys(this.targetGroup.members || {}).length}})</span>
                </span>
              </div>
              <template>
                <div class="ibox-child">
                  <div class="search-resultview">
                    <ul>
                      <li v-for="user in getUsersInfo" :key="user.id"><label>
                        <router-link :to="{ name: 'User', params: { userId: user.userId }}">
                          <span class="search-userimg">
                            <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                            <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                          </span>
                        </router-link>
                        <div class="search-userinfo">
                          <span class="search-username">{{ user.userInfo.userName }}</span>
                          <span class="search-userdept">{{ user.userInfo.dept }}</span>
                        </div>
                      </label></li>
                    </ul>
                  </div>
                </div>
              </template>
            </div>
          </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import GroupDropDown from '@/components/People/GroupDropDown'
import OrganizationItem from '@/components/People/OrganizationItem'
import { mapGetters } from 'vuex'

function compareNumbers (a, b) {
  return a.length - b.length
}

export default {
  name: 'OrganizationList',
  components: {
    GroupDropDown,
    OrganizationItem
  },
  data: function () {
    return {
      tag: 'organizationList',
      searchText: '',
      open: false,
      result: false,
      newOrganization: true,
      currentGroups: [],
      organizationOpens: {},
      organizations: [],
      organizationKeys: [],
      groups: {},
      targetGroup: {
        members: {},
        groupName: ''
      },
      targetGroupId: ''
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'OrganizationList'
    },
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('organizations/', [
      'getOnlyOrganizationsByText',
      'getCurrentTree',
      'getOpenOrganization'
    ]),
    ...mapGetters('users/', [
      'getUsersByIds'
    ]),
    ...mapGetters('groups/', [
      'getGroupsByText',
      'getGroupById',
      'getGroupsByIds',
      'getCurrentGroups',
      'getGroups'
    ]),
    getUserTree: function () {
      console.log('testtree:', this.getCurrentTree)
      let opens = []
      for (let root of Object.keys(this.getCurrentTree)) {
        console.log('rootorganization:', root)
        opens.push(this.getCurrentTree[root]['node'])
      }
      console.log('usertree:', opens)
      return opens
    },
    organizationSearch: function () {
      let searchOpens = {roots: [], node: []}
      let getOpenAllOrganizations = this.getOpenOrganization(Object.keys(this.getOrganizationsBySearchText))
      searchOpens['roots'] = Object.keys(this.getOpenOrganization(Object.keys(this.getOrganizationsBySearchText)))
      for (let ser of Object.values(this.getOpenOrganization(Object.keys(this.getOrganizationsBySearchText)))) {
        searchOpens['node'] = searchOpens['node'].concat(ser['node'])
      }
      // {a:[],b:[],c:[]}
      console.log('searchopens:search', searchOpens, getOpenAllOrganizations)
      return searchOpens
    },
    getOrganizationsBySearchText: function () {
      if (this.searchText.length === 0) {
        return this.getGroups
      } else {
        return this.getOnlyOrganizationsByText(this.searchText)
      }
    },
    getOpens: function () {
      let searchOpens = {roots: [], node: []}
      let getOrganization = {}
      for (let x of Object.keys(this.getCurrentGroups)) {
        if (this.getGroupById(x).hasOwnProperty('isOrganization')) {
          getOrganization[x] = this.getCurrentGroups[x]
        }
      }
      searchOpens['roots'] = Object.keys(this.getOpenOrganization(Object.keys(getOrganization)))
      for (let ser of Object.values(this.getOpenOrganization(Object.keys(getOrganization)))) {
        searchOpens['node'] = searchOpens['node'].concat(ser['node'])
      }
      // {a:[],b:[],c:[]}
      console.log('searchopens:', searchOpens)
      return searchOpens
    },
    getGroupsBySearchText: function () {
      if (this.searchText.length === 0) {
        return this.getGroups
      } else {
        return this.getGroupsByText(this.searchText)
      }
    },
    getUsersInfo: function () {
      return this.getUsersByIds(Object.keys(this.targetGroup.members || {}))
    },
    /* getCurrentGroupsInfo: function () {
      let currentgroups = Object.keys(this.getGroups)
      this.currentGroups = currentgroups
    },
    */
    getCurrentGroupsInfo: function () {
      return this.getCurrent()
    },
    returnCurrentTree: function () {
      console.log(this.getCurrentTree)
    },
    getOrganizationInfo: function () {
      if (this.newOrganization) {
        let groups = this.getGroupsByIds(Object.keys(this.getGroups))
        delete groups['.key']
        this.groups = groups
        let childRoute = []
        if (Object.keys(groups).length > 0) {
          let currentGroups = Object.keys(this.getCurrentGroups)
          if (currentGroups.length > 0) {
            for (let child of currentGroups) {
              if (child === '.key') {
                continue
              }
              let route = []
              let linking = false
              let childparent = child
              let childEnd = true
              if (groups[child] && groups[child].childGroups) {
                for (let grandChild of Object.keys(groups[child].childGroups)) {
                  if (currentGroups.indexOf(grandChild) > 0) {
                    childEnd = false
                    break
                  }
                }
              }
              if (childEnd) {
                let deleteTreeCheck = true
                do {
                  linking = false
                  if (groups[childparent] && groups[childparent].hasOwnProperty('parentGroup')) {
                    childparent = groups[childparent].parentGroup
                    let organized = false
                    for (let organ in childRoute) {
                      if (childRoute[organ][childRoute.length - 1] === childparent) {
                        // 過去に作られてる木に繋げれるなら繋ぐ
                        let concatRoute = route.reverse()
                        childRoute[organ] = childRoute[organ].concat(concatRoute)
                        organized = true
                      } else if (deleteTreeCheck) {
                        // 過去に今作っている木よりも大きい自分の木があれば消す
                        if (childRoute[organ].includes(child)) {
                          organized = true
                        }
                        deleteTreeCheck = false
                      }
                    }
                    route.push(childparent)
                    linking = true
                    if (organized) {
                      route = []
                      break
                    }
                  }
                } while (linking)
              }
              if (route.length > 0) {
                let routeReverse = route.reverse()
                childRoute.push(routeReverse)
                this.organizationOpens[routeReverse[0]] = routeReverse
              }
            }
          }
        }
        childRoute.sort(compareNumbers)
        if (Object.keys(groups).length > 0) {
          for (let group in groups) {
            if (groups[group].hasOwnProperty('isOrganization') && !groups[group].hasOwnProperty('parentGroup')) {
              this.organizations.push(groups[group])
              this.organizationKeys.push(group)
              this.organizationOpens[group] = false
              for (let index of childRoute) {
                if (index[0] === group) {
                  let childs = []
                  let childindex = 1 // 0は最初のorganizationのため
                  let childMaxIndex = index.length + 1
                  childs = Object.keys(groups[group].childGroups)
                  while (childs.length > 0) { // スタック
                    let child = childs.pop()
                    if (this.organizationKeys.indexOf(child) < 0) {
                      this.organizations.push(groups[child])
                      this.organizationKeys.push(child)
                    }
                    if (index[childindex] === child) {
                      if (groups[child].childGroups && childindex < childMaxIndex) {
                        for (let k of Object.keys(groups[child].childGroups)) {
                          childs.push(k)
                          childindex += 1
                        }
                      }
                    }
                  }
                }
              }
            }
            this.newOrganization = false
          }
        }
      }
      console.log('organizations', this.organizations)
      console.log('organizationKeys', this.organizationKeys)
      return this.organizations
    }
  },
  mounted: function () {
    if (this.$route.params.item) {
      this.targetGroup = this.getCurrentGroupsInfo[this.$route.params.item.group]
      this.targetGroupId = this.$route.params.item.group
      if (this.targetGroup) {
        this.open = true
      } else {
        const $t = this.$t
        this.$swal({
          title: $t('popTitleStrType'),
          text: $t('deletedOrganizationStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      }
    }
  },
  methods: {
    onClickGroup: function (id) {
      this.targetGroup = this.getGroupById(id)
      this.targetGroupId = id
      if (!this.open) {
        this.open = true
      }
    },
    getCurrent: function () {
      return this.getCurrentGroups
    },
    onClickOpenOrganization: function (groupId) {
      let groups = this.groups
      if (this.organizations[groupId].hasOwnProperty('childGroups')) {
        let childGroupss = []
        childGroupss = Object.keys(this.organizations[groupId].childGroups)
        let organizations = this.organizations
        let organizationKeys = this.organizationKeys
        if (organizationKeys.indexOf(childGroupss[0]) < 0) {
          groupId += 1
          for (let child of childGroupss) {
            Array.prototype.splice.apply(organizations, [groupId, 0].concat(groups[child]))
          }
          Array.prototype.splice.apply(organizationKeys, [groupId, 0].concat(childGroupss))
        }
        this.organizations = organizations
        this.organizationKeys = organizationKeys
        this.organizations.splice(0, 0)
      }
    },
    onClickCloseOrganization: function (group) {
      let groups = this.groups
      let childGroups = Object.keys(group.childGroups)
      while (childGroups.length > 0) {
        let childGroup = childGroups.pop()
        if (this.organizationKeys.indexOf(childGroup) < 0) {
          continue
        }
        let childGroupIndex = this.organizationKeys.indexOf(childGroup)
        this.organizations.splice(childGroupIndex, 1)
        this.organizationKeys.splice(childGroupIndex, 1)
        if (groups[childGroup].hasOwnProperty('childGroups')) {
          for (let k of Object.keys(groups[childGroup].childGroups)) {
            childGroups.push(k)
          }
        }
      }
    },
    judgeOpen: function (group, groupId) {
      if (group.hasOwnProperty('childGroups')) {
        let k = Object.keys(group.childGroups)
        return this.organizationKeys.indexOf(k[0]) > 0
      }
      return false
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/people/OrganizationList.vue